import type { AIUnifiedEventPayload } from '@atlaskit/editor-common/analytics';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { CommonStepAttributes } from '../../ui/utils/analytics/analyticsFlowTypes';

import type { NextAction, Session, UndoneSession } from './types';

type AiSessionId = string;
type TimeoutId = number;

interface AnalyticsToDefer {
	aiSessionId: AiSessionId;
	payload: AIUnifiedEventPayload;
	waitForSessionEnd: boolean;
}

export interface DeferredAnalyticsState {
	deferred: Record<AiSessionId, TimeoutId>;
	sessionState: 'notStarted' | 'inProgress' | 'justEnded';
	toCancel?: AiSessionId;
	toDefer?: AnalyticsToDefer;
}

export type CommonAttributes = Partial<CommonStepAttributes>;

export type AIMonitorWatchmenPluginState = {
	commonAttributes: CommonAttributes;
	currentSession: Session | null;

	deferredAnalytics: DeferredAnalyticsState;

	lastUndoneSession: UndoneSession | null;

	pendingAnalytics: {
		aiGroupId: string | undefined;
		aiOutputChars: number;
		aiOutputWords: number;
		aiSessionId: string;
		experienceName: string | undefined;
		nextActionLatencyMs: number;
		nextActionRemovedAiChars: number | undefined;
		nextActionRemovedAiWords: number | undefined;
		nextActionTouchedAiRanges: number | undefined;
		nextActionType: NextAction;
	} | null;
};

export const aiMonitorWatchmenPluginKey: PluginKey<AIMonitorWatchmenPluginState> = new PluginKey<AIMonitorWatchmenPluginState>(
	'aiMonitorWatchmen',
);
